<template>
  <div class="detail-contributor" v-if="detail">
    <!-- <div class="label">页面贡献者：</div> -->
    <div class="list">
      <template v-if="detail.contributor">
        <a
          v-for="(item, index) in detail.contributor.slice(0, 5)"
          :key="index"
          :href="`/user/index/${item.uid}.html`"
          target="_blank"
        >
          <div class="avatar" :title="item.username">
            <img :src="item.avatar" alt="" />
          </div>
        </a>
      </template>
    </div>
    <a
      :href="
        `${detail.game && detail.game.alias !== 'www' ? '/' + detail.game.alias : ''}/contributor?contentId=${
          detail.id
        }`
      "
    >
      <div class="more">
        共 {{ detail.contributor ? detail.contributor.length : 0 }} 人编辑
        <i class="el-icon el-icon-arrow-right"></i>
      </div>
    </a>
  </div>
</template>

<script>
export default {
  name: "DetailContributor",
  props: {
    detail: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {};
  },

  mounted() {},

  methods: {}
};
</script>

<style lang="less" scoped>
.detail-contributor {
  box-sizing: content-box;
  height: 32px;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  .label {
    margin-right: 8px;
    font-size: 12px;
    font-weight: 400;
    color: #666666;
  }
  .list {
    max-width: 648px;
    min-height: 24px;
    overflow: hidden;
    display: flex;
    gap: 12px;
    margin-right: 19px;
    .avatar {
      width: 24px;
      height: 24px;
      border-radius: 50%;
      img {
        width: 100%;
        height: 100%;
        border-radius: 50%;
        object-fit: cover;
      }
    }
  }
  .more {
    display: flex;
    align-items: center;
    font-size: 12px;
    font-weight: 400;
    color: #666666;
    .el-icon {
      font-size: 10px;
      margin-left: 9px;
    }
  }
}
</style>
